function init() {
  const notification = document.getElementById('parking-limited-availability');

  if (notification !== null) {
    notification.style.transform = 'translateX(0)';
    notification.style.opacity = '1';

    const closeButton = notification.getElementsByTagName('button')[0];
    closeButton.addEventListener('click', function (event) {
      notification.style.transitionTimingFunction = 'ease-in';
      notification.style.transitionDuration = '100ms';
      notification.style.opacity = '0';

      setTimeout(function () {
        notification.style.display = 'none';
      }, 100);
    });
  }
}

init();



// WEBPACK FOOTER //
// ./src/js/_parking-limited-availability.js